import dayjs from 'dayjs';
import { useContext, useEffect, useState, useRef } from 'react';
import { toast } from 'react-toastify';
import { useLocation } from 'react-router-dom';
import { useNavigate } from 'react-router';
import { useAppDispatch, useAppSelector } from '../../Hooks/Hooks';
import { RootState } from '../../Redux/Store';
import { AppContext } from '../../Context/AppContext';
import {
  getLoadById,
  updateUserWatchedLoads,
  handleSearchById,
  updateShowSearchResult,
  updateSearchSectionSelectedTab,
  updateSearchResultData,
  updateLoadByIdData,
  updateWatchedLoadsDataLocal,
} from '../../Redux/Reducers/SearchSlice';
import {
  SERVER_ERROR_MESSAGES,
  TOOLTIP_MESSAGE,
  WATCHED_LOAD_ADDED,
  WATCHED_LOAD_REMOVED,
} from '../../Constants/Constants';
import { showGlobalSearchMobile } from '../../Utils/Navbar.utils';
import { getContentFromUID } from '../../Pages/Support/Support';
import { TSearchTabs } from '../../Pages/Search/SearchContainer.type';
import ProfileDropdownMenu from '../Profile/ProfileDropdownMenu/ProfileDropdownMenu';
import ToolTip from '../Shared/Tooltip/Tooltip';
import './Header.scss';
import DeviceInfo from '../Shared/DeviceInfo/DeviceInfo';
import { fbLogEvent } from '../../Helpers/FirebaseHelper';
import { EVENT, SCREEN } from '../../Constants/AnalyticsConstants';
import DeviceInfoTable from '../Shared/DeviceInfoTable/DeviceInfoTable';
import { OK_TEXT } from '../../Constants/Constants';
import CustomModal from '../../Components/Shared/CustomModal/CustomModal';
import { isEntitled } from '../../Utils/ContentOrConfigUtil';
const Header = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { isMobile, module } = useContext(AppContext);
  const { pathname } = useLocation();
  const { memberData } = useAppSelector((state: RootState) => state.member);
  const { configTableData } = useAppSelector((state: RootState) => state.ContentOrConfig);
  const {
    searchResultData,
    watchedLoadsData,
    loadByIdData,
    showSearchResult,
    searchSectionSelectedTab,
  } = useAppSelector((state: RootState) => state?.search);

  const { loadDetails } = useAppSelector((state: RootState) => {
    return state?.myLoads;
  });

  const { contentStackData } = useAppSelector((state: RootState) => state.ContentOrConfig);

  const [isMenuVisible, setIsMenuVisible] = useState(false);

  const [loadData, setLoadData] = useState<any>(null);
  const [loadNumberAlias, setLoadNumberAlias] = useState<string>('');
  const [showNotification, setShowNotification] = useState<boolean>(false);
  const isFirstRender = useRef(true);

  const isSearchResults = pathname === '/search/results';
  const isProfile = pathname === '/profile';
  const isExpandedResults = pathname.includes('/expanded');
  const isMyloadsLoads = pathname === '/myloads/loads';
  const ismyloads = pathname.includes('/expanded/myloads');
  const isFinancialInfo = pathname.includes('/financial-info');
  const isMoreMobile = pathname.includes('/more-mobile/');
  const isFeedback = pathname.includes('/feedback');
  const isPreferences = pathname.includes('/preferences');
  const isMoreMobileMainPage = pathname.includes('/more-mobile');
  const isNatnal = pathname.includes('/natnal');
  const profileTitle = 'My Profile';
  const preferencesTitle = 'Preferences';
  const searchResultsTitle = 'Search Results';
  const myLoadsTitle = 'My Loads';
  const feedbackTitle = 'Feedback';
  const [deviceInfoModalProps, setDeviceInfoModalProps] = useState({
    isModalOpen: false,
  });
  useEffect(() => {
    if (isExpandedResults) {
      const id = pathname?.split('/')?.[pathname?.split('/')?.length - 1];
      const checkDateFromLoadPostings = [
        ...searchResultData?.loadPostings,
        ...watchedLoadsData?.loadPostings,
        ...loadDetails,
        loadByIdData,
      ]?.filter((item: any) => item?.loadId === id || item?.shipmentId === id)?.[0];
      if (checkDateFromLoadPostings || loadByIdData) setLoadData(checkDateFromLoadPostings);
    }
  }, [isExpandedResults, pathname, loadByIdData]);

  let currentTitle;
  switch (true) {
    case isProfile:
      currentTitle = profileTitle;
      break;
    case isPreferences:
      currentTitle = preferencesTitle;
      break;
    case isSearchResults:
      currentTitle = searchResultsTitle;
      break;
    case isMyloadsLoads:
      currentTitle = myLoadsTitle;
      break;
    case isExpandedResults:
      currentTitle =
        loadData?.loadId || loadData?.id || loadByIdData?.loadId || loadData?.shipmentId;
      break;
    case isFeedback:
      currentTitle = feedbackTitle;
      break;
    case isMoreMobile:
      const uid = pathname?.split('/')?.[pathname?.split('/')?.length - 1];
      const content: any = getContentFromUID(uid, contentStackData, () => {
        toast('Content not found');
        navigate('/more-mobile');
      });
      currentTitle = content?.heading || content?.tab_title || '';
      break;
    default:
      currentTitle = 'Search';
      break;
  }

  const handleBackNavigate = () => {
    if (isSearchResults) {
      navigate('/search');
    } else if (isMyloadsLoads) {
      navigate('/myloads');
    } else if (isProfile || isPreferences) {
      navigate('/manage');
    } else {
      navigate(-1);
    }
  };

  const closeModal = () => {
    setIsMenuVisible(!isMenuVisible);
  };

  const handleWatchToggle = () => {
    const queryPayloads = {
      operation: loadData?.isWatched ? 'DELETE' : 'ADD',
      loadId: loadData?.id || loadData?.loadId,
      watchDate: dayjs().toISOString(),
      origin: '',
      carrierId: memberData?.member?.userApplicationDetails?.[0].attributes.CommonCarrierId ?? null,
      userId: memberData?.member?.upn ?? null,
      siteId: 'FPO',
    };
    const callback = (res: any) => {
      if (res?.postingStatus === 'Success') {
        toast(loadData?.isWatched ? WATCHED_LOAD_REMOVED : WATCHED_LOAD_ADDED);
        if (!ismyloads && isExpandedResults) {
          if (loadByIdData) {
            dispatch(updateLoadByIdData({ ...loadData, isWatched: !loadData?.isWatched }));
          } else if (pathname.includes('/watched')) {
            dispatch(updateWatchedLoadsDataLocal({ id: loadData?.id || loadData?.loadId }));
            handleBackNavigate();
          } else {
            dispatch(
              updateSearchResultData({
                ...searchResultData,
                loadPostings: searchResultData?.loadPostings?.map((item: any) => {
                  if (item?.loadId === loadData?.loadId) {
                    return { ...item, isWatched: !loadData?.isWatched };
                  }
                  return item;
                }),
              }),
            );
          }
        }
        setLoadData({ ...loadData, isWatched: !loadData?.isWatched });
      } else {
        toast(res?.errorMessage ?? SERVER_ERROR_MESSAGES?.generalMsg);
      }
    };
    dispatch(updateUserWatchedLoads({ queryPayloads, callback }));
    // fbLogEvent(EVENT.UE_MARK_FAVORITE, {
    //   screen: SCREEN.SEARCH,
    //   tab: TAB.RECENT,
    //   origin: `${(item?.originCity ?? ANYWHERE) + "_"}${
    //     item?.originState ?? ""
    //   }`,
    //   destination: `${item?.destinationCity + "_"}${[
    //     item?.destinationState1,
    //     item?.destinationState2,
    //     item?.destinationState3,
    //   ]?.filter((item: any) => !!item)}`,
    // });
  };

  const handleSearch = async () => {
    if (loadNumberAlias.trim() === '') {
      return;
    }
    const payload = {
      page: 0,
      managedEquipmentCapability: 'Buy Load',
      nonManagedEquipmentCapability: 'Buy Load',
      userId: memberData?.member?.upn ?? '',
      carrierId: memberData?.member?.userApplicationDetails?.[0].attributes.CommonCarrierId ?? '',
      carrierScac: memberData?.member?.carrierScac ?? null,
      carrierTier: memberData?.member?.userApplicationDetails?.[0]?.attributes?.PayType ?? '',
      userRole: memberData?.member?.userApplicationDetails?.[0]?.roles
        ?.map((item: any) => item?.roleName)
        ?.join(','),
      loadNumberAlias: loadNumberAlias,
      siteId: 'FPO',
      rateHierarchy: 'GROUP_ONLY',
    };
    dispatch(getLoadById(payload));
    !!showSearchResult && dispatch(updateShowSearchResult(false));
    setLoadNumberAlias('');
  };

  const handleDeviceClick = () => {
    fbLogEvent(EVENT.SV_DEVICE_INFO, {
      screen: SCREEN.DEVICE_INFO_MODAL,
      lead: SCREEN.PROFILE,
    });
    const modalProps = {
      isModalOpen: true,
      title: 'Device Info',
      titleIcon: '/oo/assets/icon/info.svg',
      additionalCssClass: 'DeviceInfo_Modal',
      children: (
        <div>
          <DeviceInfoTable />
        </div>
      ),
      buttons: [
        {
          title: OK_TEXT,
          type: 'primary-cta-btn',
          onClick: () => {
            setDeviceInfoModalProps({ isModalOpen: false });
          },
        },
      ],
    };
    setDeviceInfoModalProps(modalProps);
  };

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }

    if (loadByIdData) {
      if (Object.keys(loadByIdData).length > 0) {
        dispatch(handleSearchById(true));
        if (isMobile) {
          navigate(`/expanded/new/${loadByIdData?.loadId}`);
        } else {
          dispatch(
            updateSearchSectionSelectedTab(
              searchSectionSelectedTab?.map((item: TSearchTabs) => {
                return { ...item, selected: item.slug === 'NewSearch' };
              }),
            ),
          );
          navigate('/search');
        }
      } else {
        toast('Load not found');
      }
    }
  }, [loadByIdData]);

  useEffect(() => {
    showNotification &&
      setTimeout(() => {
        setShowNotification(false);
      }, 2000);
  }, [showNotification]);

  return (
    <div
      className={`Header ${
        isMobile && !showGlobalSearchMobile(module, isMobile) && 'small'
      } ${isMobile && module?.slug === 'manage' && 'manage'} ${
        isMobile &&
        !isEntitled(memberData?.member, configTableData?.FPO_APP_CONFIG?.APP_INIT, 'globalSearch')
          ? 'globalSearch-hidden'
          : ''
      }`}
    >
      <CustomModal {...deviceInfoModalProps} />
      {!isMobile && (
        <div className="Header_Logo_Container">
          <img className="Header_Logo" src="/oo/assets/icon/sni-Logo.png" alt="logo" />
        </div>
      )}

      <div className="Header_Global_Search_Container">
        <div
          className={`Header_Title_Container ${isMobile && module?.slug === 'manage' && 'none'}`}
        >
          <div className="Header_Title_Section">
            {(isProfile ||
              isPreferences ||
              isSearchResults ||
              isMyloadsLoads ||
              isFinancialInfo ||
              isExpandedResults ||
              isFeedback ||
              isMoreMobile ||
              isNatnal) && (
              <div className="Header_Icon" onClick={() => handleBackNavigate()}>
                <img src="/oo/assets/icon/BackArrow.svg" alt="back" />
              </div>
            )}
            {isMoreMobileMainPage && !isMoreMobile && (
              <div className="Device_Info_Section">
                <DeviceInfo handleDeviceClick={handleDeviceClick} />
              </div>
            )}
            {/* {
              isExpandedResults && loadData?.shipmentId && <div className="Driver_Persona_Div">
                <div className="Persona ">
                  <span className="Persona_Name">{getPersonaName()}</span>
                </div>
              </div>
            } */}
            <div
              className={`Header_Title ${
                isMobile && module?.slug === 'more-mobile' && 'More_Title'
              }`}
            >
              {module?.label || currentTitle}
            </div>
            {isExpandedResults && !ismyloads && (
              <img
                src={`/oo/assets/icon/${
                  loadData?.isWatched ? 'watched-desktop' : 'watch-icon'
                }.svg`}
                alt={'WatcherIcon'}
                onClick={(e) => {
                  e.stopPropagation();
                  handleWatchToggle();
                }}
              />
            )}
            {pathname?.split('/')?.length <= 2 && !loadData?.isWatched && (
              <div className="Notification">
                <img
                  src="/oo/assets/icon/Notification.svg"
                  alt="Notification icon"
                  onClick={(e) => {
                    setShowNotification(true);
                  }}
                />
                {showNotification && (
                  <div className="Tooltip_Container">
                    <ToolTip
                      message={TOOLTIP_MESSAGE}
                      isActive={showNotification}
                      clearIndex={true}
                    />
                  </div>
                )}
              </div>
            )}
            {isSearchResults && (
              <div
                className="SearchEditSection"
                onClick={() => {
                  dispatch(
                    updateSearchSectionSelectedTab(
                      searchSectionSelectedTab?.map((item: TSearchTabs) => {
                        return { ...item, selected: item?.slug === 'NewSearch' };
                      }),
                    ),
                  );
                  navigate('/search', { state: { isEdit: true } });
                }}
              >
                <img src="/oo/assets/icon/edit.svg" alt="EditIcon" />
                <span>Edit</span>
              </div>
            )}
          </div>
        </div>
        {isEntitled(
          memberData?.member,
          configTableData?.FPO_APP_CONFIG?.APP_INIT,
          'globalSearch',
        ) &&
          (!isMobile || showGlobalSearchMobile(module, isMobile)) && (
            <div className="Header_Input_Row px-2">
              <div className="Input_Container">
                <input
                  type="text"
                  placeholder="Search by Load #"
                  value={loadNumberAlias}
                  onChange={(e) => setLoadNumberAlias(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                      handleSearch();
                    }
                  }}
                  tabIndex={0}
                />
                <div
                  className="Search_Icon_Container"
                  data-testid="search-onclick"
                  onClick={() => {
                    handleSearch();
                  }}
                >
                  <img src="/oo/assets/icon/search-group.svg" alt="search-icon" />
                </div>
              </div>
            </div>
          )}
      </div>
      {!isMobile && (
        <div className="Header_Profile_Container">
          <div className="Welcome_Container">
            {/* {!isMobile.any() && <Toggle />} */}
            <img
              src="/oo/assets/icon/Notification.svg"
              alt="Notification icon"
              onClick={(e) => {
                setShowNotification(true);
              }}
            />
            {showNotification && (
              <div className="Tooltip_Container">
                <ToolTip message={TOOLTIP_MESSAGE} isActive={showNotification} clearIndex={true} />
              </div>
            )}
            <span>Welcome,</span>
            <span className="Welcome_Name">
              {memberData?.member?.firstName || 'User'} {memberData?.member?.lastName}
            </span>
          </div>
          <div>
            <div className="Icons_Container">
              <img src="/oo/assets/icon/man.svg" alt="Profile icon" className="Profile_Icon" />
              <img
                src="/oo/assets/icon/grid-down-arrow-thin.svg"
                alt="Arrow icon"
                className="Arrow_Icon Menu_Dropdown_Arrow"
                onClick={() => closeModal()}
              />
            </div>
          </div>
        </div>
      )}
      <ProfileDropdownMenu
        isMenuVisible={isMenuVisible}
        handleMenuClose={() => setIsMenuVisible(false)}
      />
    </div>
  );
};

export default Header;
